<mat-form-field class="w-100">
	<mat-label>{{ placeholder }}</mat-label>
	<mat-select [required]="required" disableOptionCentering="true" (selectionChange)="selectionChange.emit($event)"
		[formControl]="selectListControl">
		<mat-option *ngIf="!required">--</mat-option>
		<mat-option *ngFor="let item of items" [value]="item">
			<div *ngIf="displayFunc; else noDisplayFunction">
				{{ displayFunc(item) }}{{unit}}
			</div>
			<ng-template #noDisplayFunction>
				{{ item }}{{unit}}
			</ng-template>
		</mat-option>
	</mat-select>
	<mat-error *ngIf="selectListControl.hasError('required')">Required</mat-error>
</mat-form-field>